<template>
  <div v-if="resolvedTags.length" class="tag-chips">
    <div
      v-for="(tag, i) in resolvedTags"
      :key="tag.key"
      class="tag-pill"
      :class="{ 'tag-pill--auto': tag.auto }"
      :style="{
        '--tag-color': TAG_COLORS[tag.color] || TAG_COLORS.grey,
        'animation-delay': `${i * 50}ms`,
      }">
      <span class="tag-pill__dot" />
      <span class="tag-pill__label">{{ tag.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  tags: { type: Array, default: () => [] },
  tagDefs: { type: Array, default: () => [] },
});

const TAG_COLORS = {
  green: "#4CAF50",
  blue: "#2196F3",
  teal: "#009688",
  purple: "#9C27B0",
  orange: "#FF9800",
  red: "#F44336",
  grey: "#9E9E9E",
};

const defMap = computed(() => {
  const map = {};
  for (const def of props.tagDefs) {
    map[def.key] = def;
  }
  return map;
});

const resolvedTags = computed(() => (props.tags || []).map((key) => defMap.value[key]).filter(Boolean));
</script>

<style lang="scss" scoped>
.tag-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.tag-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  padding: 2px 6px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--tag-color) 8%, transparent);
  animation: tag-fade-in 0.3s ease-out both;
}

.tag-pill--auto {
  border: 1px dotted color-mix(in srgb, var(--tag-color) 40%, transparent);
}

.tag-pill__dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--tag-color);
  flex-shrink: 0;
}

.tag-pill__label {
  font-family: "DM Sans", sans-serif;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--tag-color);
  line-height: 1;
  white-space: nowrap;
}

@keyframes tag-fade-in {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
